import { styled } from "@mui/material";
import { getWallpaperBgColor } from "../../../../utils/helpers";

export const Container = styled("div")(({ theme, isVisible }) => ({
  display: "flex",
  position: "relative",
  gap: "24px",
  flexDirection: "column",
  padding: "24px 16px",
  ...(isVisible && {
    transform: "translateX(1px)",
  }),
  minWidth: "30vw",
  height: "92vh",
}));

export const Header = styled("div")(({ theme }) => ({
  width: "100%",
  borderBottom: "1px solid #DED8E1",
}));

export const WheelListingContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

export const WheelCardContainer = styled("div")(() => ({
  display: "flex",
  width: "100%",
  gap: "8px",
  padding: "8px",
  borderRadius: "8px",
  border: "1px solid #EAECF0",
  alignItems: "center",
  cursor: "pointer",

  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "#efe9fe",
  },
}));

export const WheelCardImage = styled("img")(() => ({
  width: "66px",
  height: "66px",
  objectFit: "cover",
  borderRadius: "4px",
  border: "1px solid #F9FAFB",
}));

export const DefaultWheelContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100px",
  height: "66px",
  borderRadius: "4px",
  border: "1px solid #F9FAFB",
  background: `
    conic-gradient(from 180deg at 50% 50%, #F5EEDE -41.73deg, #F7FED5 53.81deg, #CCFEFF 133.87deg, #FDCFFE 244.39deg, #F5EEDE 318.27deg, #F7FED5 413.81deg),
    linear-gradient(0deg, rgba(255, 255, 255, 0.46), rgba(255, 255, 255, 0.46))
  `,
}));

export const ActionIconsContainer = styled("div")(() => ({
  display: "flex",
  gap: "6px",
  alignItems: "center",
  marginLeft: "auto",
}));

export const ActionIcon = styled("img")(() => ({
  width: "24px",
  height: "24px",
}));

export const SegmentsContainer = styled("div")(() => ({
  backgroundColor: "#F9FAFB",
  borderRadius: "8px",
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  border: "1px solid  #EAECF0",
}));

export const Separator = styled("div")(() => ({
  width: "100%",
  height: "1px",
  backgroundColor: "#EAECF0",
}));

export const Segments = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  overflowY: "auto",
  maxHeight: "50vh",
}));

export const SegmentItem = styled("div")(() => ({
  display: "flex",
  flex: 1,
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#F3F4F6",
  },
}));

export const SegmentName = styled("div")(
  ({ color, bgColor, borderColor, isSelected }) => ({
    display: "flex",
    flex: 0.9,
    gap: "8px",
    backgroundColor: getWallpaperBgColor(color, 0.3),
    borderRadius: "8px",
    border: `1px solid ${borderColor ? borderColor : color}`,
    padding: "12px",
    cursor: "pointer",
    ...(isSelected && {
      // backgroundColor: "#F2EFFF", // Removed background color
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)", // Darker shadow
    }),
  })
);

export const SegmentColorIndicator = styled("div")(({ color }) => ({
  display: "flex",
  alignSelf: "center",
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  backgroundColor: color,
  flexShrink: 0,
}));

export const IconContainer = styled("div")(({ isSelected }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "44px",
  height: "44px",
  borderRadius: "8px",
  border: `1px solid ${isSelected ? "#6B21A8" : "#BBBBBB"}`,
  cursor: "pointer",
  ...(isSelected && {
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)", // Darker shadow
  }),
}));

export const SegmentPreviewContainer = styled("div")(() => ({
  position: "fixed",
  top: "7%",
  right: "35%",
  width: "auto",
  height: "95%",
  zIndex: 9999,
  padding: "15px",
  borderRadius: "8px",
  backgroundColor: "#fff",
}));

export const ButtonContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  marginTop: "12px",
}));

export const InputContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const NoDataFoundContainer = styled("div")(({ noBorder }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "200px",
  gap: "16px",
  ...(!noBorder && { border: "1px dashed #98A2B3" }),
}));

export const CardImageContainer = styled("div")(({ bg }) => {
  let background = "#F6F7F9";
  const isImageUrl = (bg) => /^(http|https|data):/.test(bg);

  if (isImageUrl(bg)) {
    background = `url(${bg}) center/cover no-repeat`;
  } else if (bg) {
    background = bg;
  }

  return {
    width: "100px !important",
    background,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    maxHeight: "66px",
    overflow: "hidden",
  };
});
